import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { bootstrap } from 'bootstrap5/dist/js/bootstrap.bundle';
import { ZiggyVue } from '../../../vendor/tightenco/ziggy/dist';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { VueReCaptcha } from 'vue-recaptcha-v3';


// function resolvePage(name) {
//     const [page, module] = name.split('::');
//     console.log(page, module);
//     const pagePath = module
//         ? `../../Modules/${module}/Resources/assets/js/Pages/${page}`
//         : `./Pages/${page}`;

//     const pages = module
//         ? require(`../../Modules/**/Resources/assets/js/Pages/${name}`)
//         : require(`./Pages/${name}`);

//     if (!pages[pagePath]) {
//         const errorMessage = `Page not found: ${pagePath}`;
//         console.log(errorMessage);
//         throw new Error(errorMessage);
//     }

//     return typeof pages[pagePath] === 'function' ? pages[pagePath]() : pages[pagePath];
// }

createInertiaApp({
    //resolve: async (name) => await resolvePage(name),
    resolve: (name) => {
        let page = null;
        let isModule = name.split("::");

        if (isModule.length > 1) {
            let module = isModule[0];
            let path = isModule[1];

            page = require(`../../../Modules/${module}/Resources/js/front/Pages/${path}.vue`);
        } else {
            page = require(`./Pages/${name}`);
        }

        return page;
    },
    setup({ el, App, props, plugin }) {
        const application = createApp({ render: () => h(App, props) });
        const recaptchaKey = props.initialPage.props.recaptcha.api_site_key ?? null;
        application.config.globalProperties.$filters = {
            chunk(array, size) {
                let chunkedArray = [];
                let index = 0;

                while (index < array.length) {
                    chunkedArray.push(array.slice(index, size + index));
                    index += size;
                }

                return chunkedArray;
            },
            validateNumberInput(number) {
                return number.replace(/[^0-9]/g, '');
            }
        }
        application
            .use(plugin)
            .use(bootstrap)
            .use(ZiggyVue)
            .use(VueDOMPurifyHTML)
            .use(VueReCaptcha, { siteKey: recaptchaKey })
            .mount(el);
        delete el.dataset.page

        return application;
    },
})
